var lot = ixModuleRouting("impactx.lot", {
    "/lot/:id/:useSetFilter?": {
        templateUrl: "modules/lot/lot.html",
        controller: "LotCtrl",
        controllerAs: "lotCtrl",
        workspace: "shop",
    },
    "/lotlist": {
        template: "<ixa-lot-list></ixa-lot-list>",
        templateUrl: "modules/lot/templates/lotlist.html",
        process: "ListLot",
        controller: "LotListCtrl",
        controllerAs: "lotListCtrl",
        workspace: "content",
    },
    "/lotlist/tender/:tenderId": {
        template: "<ixa-lot-list-for-tender></ixa-lot-list-for-tender>",
        templateUrl: "modules/lot/templates/lotlist.html",
        process: "ListLot",
        controller: "LotListForTenderCtrl",
        controllerAs: "lotListCtrl",
        workspace: "content",
    },
    "/lotbuyerlist/:lotId": {
        template: "<ixa-lot-buyer-list></ixa-lot-buyer-list>",
        templateUrl: "modules/lot/templates/lotbuyerlist.html",
        process: "ListLotBuyer",
        controller: "LotBuyerListCtrl",
        controllerAs: "lotBuyerListCtrl",
        workspace: "content",
    },
    "/lotsupplierlist/:lotId": {
        template: "<ixa-lot-supplier-list></ixa-lot-supplier-list>",
        templateUrl: "modules/lot/templates/lotsupplierlist.html",
        process: "ListLotSupplier",
        controller: "LotSupplierListCtrl",
        controllerAs: "lotSupplierListCtrl",
        workspace: "content",
    },
    "/lotdetail/:id": {
        template: "<ixa-lot-detail></ixa-lot-detail>",
        templateUrl: "modules/lot/templates/lotdetail.html",
        process: "ViewLotDetail",
        controller: "LotDetailCtrl",
        controllerAs: "lotDetailCtrl",
        workspace: "content",
    },
    "/lotbuyerdetail/:id/:lotId": {
        template: "<ixa-lot-buyer-detail></ixa-lot-buyer-detail>",
        templateUrl: "modules/lot/templates/lotbuyerdetail.html",
        process: "ViewLotBuyer",
        controller: "LotBuyerDetailCtrl",
        controllerAs: "lotBuyerDetailCtrl",
        workspace: "content",
    },
    "/lotsupplierdetail/:id/:lotId": {
        template: "<ixa-lot-supplier-detail></ixa-lot-supplier-detail>",
        templateUrl: "modules/lot/templates/lotsupplierdetail.html",
        process: "ViewLotSupplier",
        controller: "LotSupplierDetailCtrl",
        controllerAs: "lotSupplierDetailCtrl",
        workspace: "content",
    },
    "/lotsubsupplierlist/:lotSupplierId": {
        template: "<ixa-lot-sub-supplier-list></ixa-lot-sub-supplier-list>",
        templateUrl: "modules/lot/templates/lotsubsupplierlist.html",
        process: "ListLotSubSupplier",
        controller: "LotSubSupplierListCtrl",
        controllerAs: "lotSubSupplierListCtrl",
        workspace: "content",
    },
    "/lotsubsupplierdetail/:id/:lotSupplierId": {
        template: "<ixa-lot-sub-supplier-detail></ixa-lot-sub-supplier-detail>",
        templateUrl: "modules/lot/templates/lotsubsupplierdetail.html",
        process: "ViewLotSubSupplier",
        controller: "LotSubSupplierDetailCtrl",
        controllerAs: "lotSubSupplierDetailCtrl",
        workspace: "content",
    },
    "/mostusedlots": {
        template: "<ixa-most-used-lot-list></ixa-most-used-lot-list>",
        templateUrl: "modules/lot/templates/lotgrid.tmpl.html",
        process: "MostUsedLots",
        controller: "MostUsedLotCtrl",
        controllerAs: "mostUsedLotCtrl",
        workspace: "shop",
    },
    "/newestlots": {
        template: "<ixa-newest-lot-list></ixa-newest-lot-list>",
        templateUrl: "modules/lot/templates/lotgrid.tmpl.html",
        controller: "NewestLotCtrl",
        controllerAs: "newestLotCtrl",
        workspace: "shop",
    }
});
